export default {
  postIDs: {
    nl: {},
    fr: {}
  }
}
